export default __webpack_public_path__ + "static/info-solutions-e2ea59355522c0213f6909186aa1c0c8.png";